import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  labels: { title: string; body: string; reload: string };
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: unknown): void {
    console.error("[Brainy Bots] Uncaught error:", error);
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="app">
          <section className="card" role="alert">
            <h2>😿 {this.props.labels.title}</h2>
            <p>{this.props.labels.body}</p>
            <div className="btn-row">
              <button
                className="btn pink"
                onClick={() => window.location.reload()}
              >
                {this.props.labels.reload}
              </button>
            </div>
          </section>
        </div>
      );
    }
    return this.props.children;
  }
}
